export default __webpack_public_path__ + "static/media/LAS0920.34I-41372_-25434_0.a96f4084.jpg";